import Store from '@/store/computed/storeHelpers'

export default {
  data() {
    return {
      allPossibleHeaders: [
        {
          text: 'ID',
          align: 'left',
          type: 'text',
          value: 'id'
        },
        {
          text: 'Billing Period',
          align: 'left',
          value: 'trip.docket.billingPeriod',
          type: 'text'
        },
        {
          text: 'Date',
          align: 'left',
          value: 'trip.docket.date',
          type: 'date'
        },
        {
          text: 'Customer Claim Reference',
          align: 'left',
          value: 'customerClaimRef',
          type: 'text'
        },
        {
          text: 'Project',
          align: 'left',
          value: 'trip.docket.site.project.name',
          type: 'text'
        },
        {
          text: 'Site',
          align: 'left',
          value: 'trip.docket.site.name',
          type: 'text'
        },
        {
          text: 'Trip ID',
          align: 'right',
          value: 'tripId',
          type: 'text'
        },
        {
          text: 'Spoil',
          align: 'left',
          value: 'trip.spoil.name',
          type: 'text'
        },
        {
          text: 'Tip',
          align: 'left',
          value: 'trip.tip.name',
          type: 'text'
        },
        {
          text: 'Bill Quantity',
          align: 'right',
          type: 'text',
          decimals: 2,
          value: 'qty'
        },
        {
          text: 'Bill Rate',
          align: 'right',
          value: 'rate',
          decimals: 2,
          type: 'curr'
        },
        {
          text: 'Bill Amount',
          align: 'right',
          value: 'amount',
          decimals: 4,
          type: 'curr'
        },

        {
          text: 'Total Approved',
          align: 'right',
          value: 'trip.approvedBillingAmount',
          decimals: 4,
          type: 'curr'
        },
        {
          text: 'Waived',
          align: 'right',
          value: 'trip.waivedAmount',
          decimals: 2,
          type: 'curr'
        },
        {
          text: 'Trip Rate',
          align: 'right',
          type: 'curr',
          decimals: 2,
          value: 'trip.sellPrice'
        },
        {
          text: 'Trip Total',
          align: 'right',
          value: 'trip.sellTotal',
          decimals: 4,
          type: 'curr'
        },
        {
          text: 'Outstanding',
          align: 'right',
          value: 'trip.outstandingBillingAmount',
          decimals: 2,
          type: 'curr'
        },
        {
          text: 'Notes',
          align: 'left',
          value: 'notes',
          type: 'tooltip'
        },
        {
          text: 'Bill Line ID',
          align: 'right',
          value: 'billLineId',
          type: 'text'
        },
        {
          text: 'Created By',
          align: 'left',
          value: 'createdBy.name',
          type: 'text'
        },
        {
          text: 'Created At',
          align: 'right',
          value: 'createdAt',
          type: 'date'
        },
        {
          text: 'Updated At',
          align: 'left',
          value: 'updatedAt',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    filterHeaders() {
      return this.allPossibleHeaders.filter(header => {
        if (header.value == 'actions') {
          return true
        }
        return !!this.defaultHeaders.filter(field => {
          return header.value == field
        }).length
      })
    }
  },
  computed: {
    defaultHeaders: Store.getSet({
      store: 'shared',
      prop: 'approvedBillLineDefaultHeaders'
    }),
    headers() {
      var tempArray = this.filterHeaders()
      var actions = {
        text: 'Actions',
        align: 'center',
        value: '',
        sortable: false,
        type: 'action'
      }
      tempArray.push(actions)
      return tempArray
    }
  }
}
